import { Button, type ButtonProps } from '@mantine/core';
import { IconDeviceFloppy } from '@tabler/icons-react';
import { i18nKeys } from 'locales';
import { useTranslation } from 'locales/logic';

export const SaveButton = ({
  label,
  hideIcon,
  ...rest
}: ButtonProps &
  React.ButtonHTMLAttributes<HTMLButtonElement> & { label?: string; hideIcon?: boolean }) => {
  const { t } = useTranslation();

  return (
    <Button h={32} leftSection={!hideIcon && <IconDeviceFloppy stroke={1.5} size={18} />} {...rest}>
      {label ?? t(i18nKeys.SAVE)}
    </Button>
  );
};
